import { modalController } from '@ionic/core';

export class RequestAccessController {
  static async presentModal(projectId: string, requestedPage: string, requestedRole: string, callback: Function = null): Promise<void> {
    const modal = await modalController.create({
      component: 'request-access',
      cssClass: 'modal-height-auto',
      backdropDismiss: false,
      componentProps: { projectId, requestedPage, requestedRole, canDismiss: true },
    });

    modal.addEventListener('requested', () => {
      if (callback) callback(this);
      modal.dismiss();
    });

    modal.addEventListener('dismiss', () => {
      modal.dismiss();
    });

    return await modal.present();
  }
}
